// extracted by mini-css-extract-plugin
export var actions = "_a5-8";
export var arrow = "_a5-5";
export var card = "_a5-0";
export var cardWrapper = "_a5-9";
export var fieldName = "_a5-3";
export var newValue = "_a5-6";
export var oldValue = "_a5-4";
export var orangeGlowFade = "_a5-c";
export var productSection = "_a5-1";
export var scrollToBottom = "_a5-b";
export var scrollToBottomAnchor = "_a5-a";
export var scrollToBottomIcon = "_a5-d";
export var showAllButton = "_a5-7";
export var table = "_a5-2";